import { orderCreateSlice } from '../slices/orderCreateSlice';

export default orderCreateSlice.reducer;
